module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA5UlEQVQ4jdXUP0oDQRSA8Z9L1JQGtBBt0qaw9Ay2KWwEcQvFS9gaEGsR/1zAE4TkCqnS2FgIgrWVaCSIhVMsGtmdzTR+8BiY9+abN8MwC3mei2QHZ1jHPgbFZBYh6qAfYgtruMRSrHAVFxiH7oq0cVycaJTIujjBCp7+qNnDFT6Kwg0szygeY7dkU9jEBM8N3OCwwqIq3GbIE8ngIFN+jzEsxjybStTt7hUjTFMIp9jG/axknSM/BNkdhj+TdTpshvERLymEbRzhHJ9ozSuE6xC/SP5s/ofwPaHvLcOp769nXibofQEXjCNZWzLjLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_wallet.png
// module id = ioXU
// module chunks = 1